import { getMissingRequiredProfileKeys } from '../../helpers/requiredProfileMembers';

type MissionBasicInformation = {
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  profiles?: readonly { key?: string; value?: string }[];
  profileMembers?: readonly { key?: string }[];
};

// Use the same requirements as the profile-completion popups for every acceptance entry point.
export const hasMissionBasicInformation = (profile: MissionBasicInformation): boolean =>
  !!profile.firstName && !!profile.lastName && !!profile.phoneNumber &&
  getMissingRequiredProfileKeys(profile).length === 0;
